/**
 * Story 8.12 — Onglet Références en lecture seule (modale profil membre)
 * Affiche les 3 références avec tous les champs texte.
 * Pas de boutons d'édition ni d'upload photo.
 */
import React from 'react';
import type { ProfileData, Reference } from '../../../../../services/profileService';

interface ReadOnlyReferencesProps {
    data: ProfileData;
}

// Extension du ProfileData pour inclure les références (ajouté par 8.12a)
interface ProfileDataWithRefs extends ProfileData {
    references?: Reference[];
}

const ReadOnlyReferences: React.FC<ReadOnlyReferencesProps> = ({ data }) => {
    const references = (data as ProfileDataWithRefs).references ?? [];

    return (
        <div className="readonly-tab readonly-references">
            <section className="readonly-section">
                <div className="readonly-section-title">Références</div>
                <p className="readonly-hint">3 références sont obligatoires pour compléter le profil.</p>

                {references.length === 0 ? (
                    <p className="readonly-empty">Aucune référence renseignée.</p>
                ) : (
                    <div className="readonly-references-list">
                        {references.map((ref, index) => (
                            <div key={ref.numero} className="readonly-reference-card">
                                <div className="readonly-reference-header">
                                    <h4>Référence {ref.numero}</h4>
                                    <span className={`readonly-ref-badge ${ref.is_complete ? 'complete' : 'incomplete'}`}>
                                        {ref.is_complete ? 'Complète' : 'Incomplète'}
                                    </span>
                                </div>
                                <div className="readonly-grid two-cols">
                                    <div className="readonly-field">
                                        <label>Nom de l'opération</label>
                                        <p>{ref.nom_operation || '-'}</p>
                                    </div>
                                    <div className="readonly-field">
                                        <label>Client</label>
                                        <p>{ref.client || '-'}</p>
                                    </div>
                                </div>
                                <div className="readonly-grid two-cols">
                                    <div className="readonly-field">
                                        <label>Budget</label>
                                        <p>{ref.budget ? `${ref.budget.toLocaleString('fr-FR')} €` : '-'}</p>
                                    </div>
                                    <div className="readonly-field">
                                        <label>Année de livraison</label>
                                        <p>{ref.annee_livraison || '-'}</p>
                                    </div>
                                </div>
                                <div className="readonly-field">
                                    <label>Descriptif</label>
                                    <p className="readonly-text-block">{ref.descriptif || '-'}</p>
                                </div>
                                {ref.has_photo && (
                                    <div className="readonly-field">
                                        <label>Photo</label>
                                        <p className="readonly-photo-info">Photo disponible ({ref.photo_filename})</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default ReadOnlyReferences;
